'use strict';

const endnote = {
  endnoteSection: document.querySelector('.endnote-section'),
  endnoteTitle: document.querySelector('.endnote-title'),
  endnoteContent: document.querySelector('.endnote-content'),
  init() {
    let dataEndnoteCount = 1;
    const endnoteMarks = document.querySelectorAll('*[data-endnote]');
    for (let index = 0; index < endnoteMarks.length; index++) {
      endnoteMarks[index].innerHTML = '<a href="#en:' + dataEndnoteCount + '" class="endnote">' + dataEndnoteCount + '</a>';
      dataEndnoteCount++;
    }

    const endnotes = document.querySelectorAll('.endnote');
    for (let index = 0; index < endnotes.length; index++) {
      endnotes[index].addEventListener('click', this.handle.bind(this));
    }

    document.querySelector('.endnote-close').addEventListener('click', this.close.bind(this));
  },
  handle(e) {
    e.preventDefault();

    const content = document.getElementById(e.target.hash.replace('#', '')).firstChild;

    this.endnoteTitle.textContent = 'Note ' + e.target.textContent;

    if (!this.endnoteSection.classList.contains('is-active') || this.endnoteContent.innerHTML != linkify(content.innerHTML)) {
      this.endnoteContent.innerHTML = linkify(content.innerHTML);
      requestAnimationFrame(() => {
        this.endnoteSection.classList.add('is-active');
      });
    } else {
      requestAnimationFrame(() => {
        this.endnoteSection.classList.remove('is-active');
        // this.endnoteContent.innerHTML = '';
      });
    }
  },
  close(e) {
    e.preventDefault();
    requestAnimationFrame(() => {
      this.endnoteSection.classList.remove('is-active');
      // this.endnoteContent.innerHTML = '';
    });
  }
};

export default endnote;
